import { useState } from 'react';

export const useModal = <T>() => {
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem] = useState<T | undefined>();

  const open = (itemToOpen: T) => {
    setItem(itemToOpen);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setItem(undefined);
  };

  return { isOpen, item, open, close };
};

export const useSimpleModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return { isOpen, open, close };
};
